import React, { useState, useEffect } from 'react'
import { Container, Spinner, Table } from 'react-bootstrap';
import { DatatableWrapper, Pagination, TableBody, TableHeader } from 'react-bs-datatable';
import fuziElevatorsApi from '../../api/fuziElevatorsApi';
import { ROUTES } from '../../constants/webRouting';
import { Link } from 'react-router-dom';
import { formatDate,formatDateForView } from '../../utils/helper';


const RelatedListWarranty = (props) => {
    const [body, setBody] = useState([]);

    async function init() {
        let warranties = await fuziElevatorsApi.fetchWarrantyByOrderId(props?.order?.id);
        //console.log('warranties', warranties);
        if (warranties && warranties?.length > 0) {
            setBody(warranties);
        } else {
            setBody([]);
        }
    }

    useEffect(() => {
        init();
    }, [props?.refreshSiteVisitList]);


    const header = [
        {
            title: "Order", prop: "order_id", isFilterable: true, cell: (row) => (
                <Link to={`${ROUTES.WARRANTY.LIST}/${row.id}`} state={row}>
                    {row.offer_name_label}
                </Link>
            ),
        },
        //formatDateForView added by shahir hussain 27-08-2025
        { title: "Warranty Start Date", prop: "warranty_start_date", isFilterable: true, cell: (row) => (row?.warranty_start_date ? formatDateForView(row.warranty_start_date) : '') },
        { title: "Warranty Expiry Date", prop: "warranty_end_date", isFilterable: true, cell: (row) => (row?.warranty_end_date ? formatDateForView(row.warranty_end_date) : '') },
        { title: "Email", prop: "email", isFilterable: true },
        { title: "Phone", prop: "phone", isFilterable: true },
        { title: "Site Address", prop: "site_address", isFilterable: true },
        { title: "Warranty Status", prop: "warranty_status" }, 
        { title: 'Assign User', prop: 'owner_id', cell: (row) => <Link to={ROUTES.USER + row.owner_id} state={row}> {row.owner_name} </Link> },

    ];

    return (
        <Container>
            <DatatableWrapper
                body={body}
                headers={header}
                paginationOptionsProps={{
                    initialState: {
                        rowsPerPage: 5
                    }
                }}
            >
                <Table striped className="related-list-table shadow rounded sm" responsive={true}>
                    <TableHeader classes={{ th: 'bg-custom text-white' }} />
                    {(body && Array.isArray(body)) ?
                        <TableBody />
                        :
                        <tbody className="">
                            <tr>
                                <td colSpan={100} align="center">
                                    <div>
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    }
                </Table>
                <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
            </DatatableWrapper>
        </Container>
    )
};

export default RelatedListWarranty
